module.exports = {
	"name": "luma.gl",
	"version": "3.0.2",
	"description": "A WebGL JavaScript visualization library.",
	"license": "MIT",
	"contributors": [
		{
			"name": "Ib Green",
			"email": "ib@uber.com"
		},
		{
			"name": "Nicolas Belmonte",
			"email": "nico@uber.com"
		},
		{
			"name": "Rye Terrell"
		},
		{
			"name": "Shan He",
			"email": "shan@uber.com"
		},
		{
			"name": "Mikola Lysenko"
		},
		{
			"name": "Wesam Manassra",
			"email": "manassra@uber.com"
		}
	],
	"repository": {
		"type": "git",
		"url": "git+https://github.com/uber/luma.gl.git"
	},
	"keywords": [
		"webgl",
		"visualization",
		"animation",
		"3d"
	],
	"main": "dist/index.js",
	"module": "dist-es6/index.js",
	"files": [
		"src",
		"dist",
		"dist-es6",
		"headless.js"
	],
	"scripts": {
		"start-webpack": "(cd examples/main && yarn && npm run start-local)",
		"start": "npm run build-watch && budo dist/bundle.js:dist/lumagl.js --live --open --port 3000 --watch-glob '**/*.{html,css,js,glsl}' ",
		"build-watch": "babel src -d dist --source-maps inline --copy-files --watch & babel examples -d dist --source-maps inline --copy-files --watch &",
		"build-clean": "rm -fr dist dist-es6 && mkdir -p dist dist-es6 ",
		"build-es6": "rm -fr dist-es6 && babel src --out-dir dist-es6 --plugins=static-fs --source-maps inline",
		"build-es5": "rm -fr dist && babel src --out-dir dist --plugins=static-fs,transform-es2015-modules-commonjs --source-maps inline",
		"build-buble": "rm -fr dist-buble && mkdir -p dist-buble && buble src -o dist-buble --no modules --y dangerousForOf --objectAssign",
		"build": "npm run build-es6 && npm run build-es5",
		"build-shaders": "find . -name '*.glsl' -type f -exec bash -c 'echo \"export default `\\\" \"$1\" \"`;\"' -- {} \\;",
		"build-shaders2": "find . -name '*.glsl' -type f -exec bash -c 'echo \"export default `\\\" ; cat \"$1\" ; echo \"`;\" \"${1/glsl/glsl.js}\"' -- {} \\;",
		"build-shader": "echo 'export default `\\' ; cat \"$1\" ; echo '`;'",
		"lint": "eslint src test",
		"publish-prod": "npm run build && npm run test-fast && npm publish",
		"publish-beta": "npm run build && npm run test-fast && npm publish --tag beta",
		"test": "npm run lint && npm run test-node",
		"test-fast": "npm run lint && node test/node.js | faucet",
		"test-node": "node test/node.js",
		"test-browser": "webpack-dev-server --config webpack.config.test-browser.js --progress --hot --open",
		"test-shader": "npm run build-dist && budo src/test/fp64-shader.spec.js:build/test-bundle.js --dir test --live --open --port 3001 --watch-glob '**/*.{html,css,scss,js,glsl}' -- -t babelify -t brfs-babel",
		"docs": "npm run docs-build && open ./_docs/docs/index.html",
		"docs-build": "rm -fr _docs/* && jekyll build --config=docs/_config.yml --layouts docs/_layouts",
		"docs-gh-pages": "git subtree push --prefix _docs origin gh-pages",
		"docs-gh-pages-force": "git push origin `git subtree split --prefix _docs dev`:gh-pages --force",
		"docs-publish": "npm run docs-build && git add _docs -f && git commit -m 'UPDATE DOCS' --no-verify && npm run docs-gh-pages"
	},
	"dependencies": {
		"gl-constants": "^1.0.0",
		"gl-matrix": "^2.3.2",
		"webgl-debug": "^1.0.2"
	},
	"devDependencies": {
		"babel-cli": "^6.18",
		"babel-core": "^6.18",
		"babel-eslint": "^6.0.0",
		"babel-plugin-static-fs": "^1.1.0",
		"babel-plugin-transform-builtin-extend": "^1.1.0",
		"babel-plugin-transform-decorators-legacy": "^1.3.4",
		"babel-preset-es2015": "^6.18",
		"babel-preset-stage-2": "^6.18",
		"babelify": "^7.2.0",
		"blue-tape": "^0.2.0",
		"brfs-babel": "^1.0.0",
		"browserify": "^13.0.0",
		"buble": "^0.15.1",
		"buble-loader": "^0.4.0",
		"budo": "^8.0.3",
		"disc": "^1.3.2",
		"electron-prebuilt": "^0.37.2",
		"eslint": "^3.0",
		"eslint-config-uber-es2015": "^3.0.0",
		"eslint-config-uber-jsx": "^3.0.0",
		"eslint-plugin-babel": "^4.0.0",
		"eslint-plugin-react": "~6.7.0",
		"faucet": "0.0.1",
		"gl": "^4.0.2",
		"jsdom": "^9.9.1",
		"luma.gl": "3.0.0-alpha.3",
		"mkdirp": "^0.5.1",
		"module-alias": "^2.0.0",
		"pre-commit": "^1.2.2",
		"raw-loader": "^0.5.1",
		"react": "^15.4.0",
		"react-addons-test-utils": "^15.4.2",
		"react-dom": "^15.4.0",
		"reify": "^0.4.4",
		"sinon": "^1.17.7",
		"source-map-support": "^0.4.2",
		"tap-browser-color": "^0.1.2",
		"tape": "^4.6.3",
		"tape-catch": "^1.0.4",
		"tape-promise": "^1.1.0",
		"testron": "^1.2.0",
		"transform-loader": "^0.2.3",
		"uglify-js": "^2.6.1",
		"webpack": "^2.2.0-rc.3",
		"webpack-dev-server": "^2.2.0-rc.0"
	},
	"gitHead": "021309b5c5f5a1009e4fe3e2b61eb377e88e6bfd",
	"bugs": {
		"url": "https://github.com/uber/luma.gl/issues"
	},
	"homepage": "https://github.com/uber/luma.gl#readme",
	"_id": "luma.gl@3.0.2",
	"_shasum": "0da003f104e7341d50543e55cb1cfe81f6014b00",
	"_from": "luma.gl@>=3.0.0-beta.11 <4.0.0",
	"_npmVersion": "3.10.3",
	"_nodeVersion": "6.5.0",
	"_npmUser": {
		"name": "shaojingli",
		"email": "lishaojing@gmail.com"
	},
	"dist": {
		"shasum": "0da003f104e7341d50543e55cb1cfe81f6014b00",
		"tarball": "https://registry.npmjs.org/luma.gl/-/luma.gl-3.0.2.tgz"
	},
	"maintainers": [
		{
			"name": "gnavvy",
			"email": "gnavvy@gmail.com"
		},
		{
			"name": "heshan0131",
			"email": "heshan0131@gmail.com"
		},
		{
			"name": "ibgreen",
			"email": "ib.green.home@gmail.com"
		},
		{
			"name": "pessimistress",
			"email": "cxiaoji@gmail.com"
		},
		{
			"name": "shaojingli",
			"email": "lishaojing@gmail.com"
		}
	],
	"_npmOperationalInternal": {
		"host": "packages-18-east.internal.npmjs.com",
		"tmp": "tmp/luma.gl-3.0.2.tgz_1493146580990_0.9700589096173644"
	},
	"directories": {},
	"_resolved": "https://registry.npmjs.org/luma.gl/-/luma.gl-3.0.2.tgz",
	"readme": "ERROR: No README data found!"
};


//////////////////
// WEBPACK FOOTER
// ./~/react-vis/~/luma.gl/package.json
// module id = 380
// module chunks = 0